import { AssetsService } from "app/services/AssetsService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { IActivationWizard } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { WizardRole } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import {
    AnalyzeKeywordListStep,
    CreateKeywordListStep,
    DiscoverKeywordsStep,
    GenerateTopicKeywordsStep,
    MarketingChannelsStep,
    MonitorKeywordListStep,
    TrackAndShareStep,
    TrafficAndEngagementStep,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/Activation Steps";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

const i18n = i18nFilter();

const config: Record<WizardRole, IActivationWizard> = {
    [WizardRole.General]: {
        steps: [TrafficAndEngagementStep, MarketingChannelsStep, DiscoverKeywordsStep, TrackAndShareStep],
        getCompletionStep: (allSkipped) => ({
            title: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.general.title.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.general.title",
            ),
            description: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.general.description.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.general.description",
            ),
            buttonText: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.general.button.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.general.button",
            ),
            illustration: AssetsService.assetUrl(
                allSkipped
                    ? "/images/homepage/activation-wizard-steps-skip-image.svg"
                    : "/images/homepage/activation-wizard-steps-completion-image.svg",
            ),
            onClick: () => {
                proNavigator.go("digitalsuite_websiteanalysis_home");
                allTrackers.dispatchTrackEvent(
                    "Button",
                    "click",
                    "Activation widget/Step Completion/Go To Website Analysis Homepage",
                );
            },
        }),
    },
    [WizardRole.Seo]: {
        steps: [GenerateTopicKeywordsStep, CreateKeywordListStep, AnalyzeKeywordListStep, MonitorKeywordListStep],
        getCompletionStep: (allSkipped) => ({
            title: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.seo.title.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.seo.title",
            ),
            description: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.seo.description.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.seo.description",
            ),
            buttonText: i18n(
                allSkipped
                    ? "growth.homepage.activationWizard.stepsCompletion.seo.button.skipped"
                    : "growth.homepage.activationWizard.stepsCompletion.seo.button",
            ),
            illustration: AssetsService.assetUrl(
                allSkipped
                    ? "/images/homepage/activation-wizard-steps-skip-image.svg"
                    : "/images/homepage/activation-wizard-steps-completion-image.svg",
            ),
            onClick: () => {
                proNavigator.go("digitalsuite_findkeywords_keywordGeneratorTool");
            },
        }),
    },
};

export default config;
